import React from 'react';
import PropTypes from "prop-types";

const RequestedNotification = ({notification, acceptOrReject}) => {
  const {first_name, last_name} = notification.requested_user;
  const {dock_from, dock_to} = notification;

  function getUserDisplayName(firstName, lastName) {
    return `${firstName} ${lastName}`;
  }

  return (
      <tr>
        <td>{getUserDisplayName(first_name, last_name)} request changing his booking
          from {dock_from.name} to {dock_to.name}</td>
        <td>
          <button type="button" className="manage-icons accept" onClick={() => acceptOrReject(notification.id)}><i
              className="icon-check-circle"></i></button>
          <button type="button" className="manage-icons decline" onClick={() => acceptOrReject(notification.id, false)}>
            <i className="icon-close"></i></button>
        </td>
      </tr>
  );
};

RequestedNotification.propTypes = {
  notification: PropTypes.object,
  acceptOrReject: PropTypes.func.isRequired
};

export default RequestedNotification;



// WEBPACK FOOTER //
// ./src/components/NotificationsList/RequestedNotification.jsx